import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PersonIcon from "@mui/icons-material/Person";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import ReviewsIcon from "@mui/icons-material/Reviews";

export const Icons = {
  Orders: BookmarkBorderIcon,
  Users: PersonIcon,
  Product: ShoppingCartIcon,
  Review: ReviewsIcon,
};
